module.exports = __webpack_public_path__ + "static/img/kucun_1.c78bee1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/kucun_1.png
// module id = xsQr
// module chunks = 5